import { useCallback, useState } from "react";

export function useSingleOpenMessageAction(
  initialMessageId: string | null = null,
) {
  const [activeMessageId, setActiveMessageId] = useState<string | null>(
    initialMessageId,
  );

  const isMessageOpen = useCallback(
    (messageId: string) => activeMessageId === messageId,
    [activeMessageId],
  );

  const setMessageOpen = useCallback((messageId: string, open: boolean) => {
    setActiveMessageId((prev) => {
      if (open) return messageId;
      return prev === messageId ? null : prev;
    });
  }, []);

  const closeAll = useCallback(() => {
    setActiveMessageId(null);
  }, []);

  return {
    activeMessageId,
    isMessageOpen,
    setMessageOpen,
    closeAll,
  };
}
